<div class="work-ui-progressbar">
  <div [style.width.%]="progressPercentage" class="work-ui-progressbar-fill"></div>
</div>
